import { useState } from 'react';
import { useExploreContext } from '../../core/context/ExploreContext';
import useScreenSize from '../../core/hooks/useScreenSize';
import Header from '../../components/Header/Header';
import CategoryNav from '../../components/CategoryNav/CategoryNav';
import ExploreSidebar from '../../components/ExploreSidebar/ExploreSidebar';
import SearchBar from '../../components/SearchBar/SearchBar';
import {
  StyledPageContainer,
  StyledPageSidebar,
  StyledPageContent,
  StyledPageMainContent,
} from '../../styles/config/pageStyle';

function Explore() {
  const { categories, company, exploreSidebar } = useExploreContext();
  const [searchTerm, setSearchTerm] = useState('');
  const [size] = useScreenSize();

  const handleSearch = query => setSearchTerm(query);

  return (
    <>
      <Header title="explore" />

      <StyledPageContainer>
        {size > 991 && (
          <StyledPageSidebar>
            <ExploreSidebar data={exploreSidebar} hasIcon={false} />
          </StyledPageSidebar>
        )}

        <StyledPageContent>
          <StyledPageMainContent>
            {size < 992 && <SearchBar searchQuery={handleSearch} />}
            <CategoryNav query={searchTerm} categories={categories} company={company} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default Explore;
